<template>
  <div>
    <p>{{ formattedNumber }}</p>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formattedNumber() {
      return new Intl.NumberFormat().format(this.number);
    },
  },
};
</script>
